import Vue from 'vue'
import Addtoplannergs from './Addtoplannergs.vue'

var app = new Vue({
   el: '#app',
   components: {
       'addtoplanner': Addtoplannergs,
   },
});



// WEBPACK FOOTER //
// ./scripts/addtoplannergs.js